/***
 *
 *   TICKET DUE
 *   Ported from ui-reference/src/lib/ticket-due.ts.
 *
 *   A ticket is overdue when it has a due date before today (local calendar)
 *   and is still open. Status keys come from this app's dynamic
 *   `status_template`, so we accept a key string rather than a closed enum.
 *
 **********/

const NOT_OVERDUE_STATUSES = ['completed', 'closed'];

function startOfLocalDayMs(d) {
    return new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
}

/**
 * @param {{ due_date?: string | Date | null, status?: string | null }} ticket
 *   `status` is the Valetify column key (pending / in_progress / …), not the
 *   integration status id.
 */
export function isTicketOverdue(ticket) {
    if (!ticket?.due_date) return false;
    if (ticket.status && NOT_OVERDUE_STATUSES.includes(ticket.status)) return false;
    const dueDay = startOfLocalDayMs(new Date(ticket.due_date));
    const today = startOfLocalDayMs(new Date());
    return dueDay < today;
}
